module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.90186830.eot";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.eot
// module id = ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.eot
// module chunks = 0